import { action, makeObservable, observable } from 'mobx';

export class FormStore {
  @observable selectedGroupIds: number[] = [];
  @observable groupSearchQuery: string = '';
  @observable selectedLicenseIds: number[] = [];
  @observable newGroupIdMap: Map<number, string> = new Map();
  @observable groupSuggestedLicenseIds: Set<number> = new Set();
  @observable licenseSearchQuery: string = '';
  @observable expandedLicenseTypes: Set<string> = new Set();
  @observable areLicensesAuditor: boolean = false;
  @observable showCreateGroupInput: boolean = false;
  @observable newGroupName: string = '';
  @observable showCancelConfirmation: boolean = false;
  @observable hoveredGroupTooltip: number | null = null;
  @observable hoveredCollectionTooltip: number | null = null;

  constructor() {
    makeObservable(this);
  }

  @action
  reset() {
    this.selectedGroupIds = [];
    this.groupSearchQuery = '';
    this.selectedLicenseIds = [];
    this.newGroupIdMap = new Map();
    this.groupSuggestedLicenseIds = new Set();
    this.licenseSearchQuery = '';
    this.expandedLicenseTypes = new Set();
    this.areLicensesAuditor = false;
    this.showCreateGroupInput = false;
    this.newGroupName = '';
    this.showCancelConfirmation = false;
    this.hoveredGroupTooltip = null;
    this.hoveredCollectionTooltip = null;
  }

  @action
  updateSelectedGroupIds(ids: number[]) {
    this.selectedGroupIds = ids;
  }

  @action
  updateGroupSearchQuery(query: string) {
    this.groupSearchQuery = query;
  }

  @action
  updateSelectedLicenseIds(ids: number[]) {
    this.selectedLicenseIds = ids;
  }

  @action
  updateNewGroupIdMap(map: Map<number, string>) {
    this.newGroupIdMap = map;
  }

  @action
  updateGroupSuggestedLicenseIds(ids: Set<number>) {
    this.groupSuggestedLicenseIds = ids;
  }

  @action
  updateLicenseSearchQuery(query: string) {
    this.licenseSearchQuery = query;
  }

  @action
  updateExpandedLicenseTypes(types: Set<string>) {
    this.expandedLicenseTypes = types;
  }

  @action
  updateAreLicensesAuditor(isAuditor: boolean) {
    this.areLicensesAuditor = isAuditor;
  }

  @action
  updateShowCreateGroupInput(show: boolean) {
    this.showCreateGroupInput = show;
  }

  @action
  updateNewGroupName(name: string) {
    this.newGroupName = name;
  }

  @action
  updateShowCancelConfirmation(show: boolean) {
    this.showCancelConfirmation = show;
  }

  @action
  updateHoveredGroupTooltip(id: number | null) {
    this.hoveredGroupTooltip = id;
  }

  @action
  updateHoveredCollectionTooltip(id: number | null) {
    this.hoveredCollectionTooltip = id;
  }
}

export const formStore = new FormStore();
